// extracted by mini-css-extract-plugin
module.exports = {"form_group":"forms_form_group__19gD5","control_group":"forms_control_group__lrQel","control_label":"forms_control_label__3grw3","control":"forms_control__2HXDT"};